import { useEffect, useState } from 'react'
import { loadReferenceData } from '@/services/referenceService'
import { useAuth } from '@/context/AuthContext'

export function useActionTypes(): string[] {
  const { session } = useAuth()
  const [types, setTypes] = useState<string[]>([])
  useEffect(() => {
    let active = true
    setTypes([])
    void loadReferenceData('action-types').then(rows => {
      if (active) setTypes(rows.filter(row => row.enabled).sort((a, b) => a.order - b.order).map(row => row.name))
    }).catch(() => { if (active) setTypes([]) })
    return () => { active = false }
  }, [session?.businessId])
  return types
}
